// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d8ca6697","667":"0a488697"}[chunkId] + ".chunk.js";
};